<template>
    <div class="horse-preview-date">
        <div class="label">{{label}}</div>
        <div class="value day-and-month">{{formattedDateDayAndMonth}}</div>
        <div class="value year">{{formattedDateYear}}</div>
        <div class="value additional-information"><slot name="additionalInformation"></slot></div>
    </div>
</template>

<script>

import {DateUtils} from "@/utils/DateUtils";

export default {
    name: "HorsePreviewDate",
    components: {
    },

    props: {
        label: {
            type: String,
            required: true,
        },
        value: {
            required: true,
        },
    },

    computed: {
        formattedDateDayAndMonth() {
            if (this.value == null || this.value === "") return "";

            try {
                const day = DateUtils.formatDateFromString(this.value, "DD-MM-YYYY", "D");

                const month = DateUtils.formatDateFromString(this.value, "DD-MM-YYYY", "MMMM");

                return `${day} ${month}`;
            } catch (error) {
                console.error("Error formatting date:", error);
                return "";
            }
        },

        formattedDateYear() {
            if (this.value == null || this.value === "") return "";

            try {
                return DateUtils.formatDateFromString(this.value, "DD-MM-YYYY", "YYYY");
            } catch (error) {
                console.error("Error getting year:", error);
                return "";
            }
        },
    },
};
</script>

<style lang="scss">
@import "../../../../assets/theme/mytheme/variables";
.horse-preview-date {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: var(--dates-background-color);
    color: var(--dates-text-color);
    border-radius: 7px;
    padding: 0.5rem;
    width: 40%;
    max-width: 40%;
    text-align: center;

    .label {
        font-size: 18px;
        text-transform: uppercase;
    }
    .value {
        font-family: var(--decor-font-family);
    }
    .day-and-month {
        font-size: 20px;
    }
    .year {
        font-size: 30px;
    }
    .additional-information {
        font-size: 20px;
    }
}
</style>
